import React, { useState, useRef } from "react";
import { FileUpload } from "primereact/fileupload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { Message } from "primereact/message";
import Papa, { parse } from "papaparse";
import Layout from "../../Layout";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import InputCEP from "../../../Componentes/InputTextCEP";
import { Toast } from 'primereact/toast';
import Conexao from "../../../providers/Conexao";
import { useLocation } from 'react-router-dom';
import { Chip } from 'primereact/chip';


const ImportClientesCSV = () => {
  const [data, setData] = useState([]);
   const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fileUploadRef = useRef(null);
  const [selectedData, setSelectedData]= useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0)
  const { dataEmpresa } = location.state || {};
 

  const [editando, setEditando] = useState(-1);
  const [cliente, setCliente] = useState({
    razaosocial : '', 
    nomefantasia : '', 
    cpf_cnpj : '', 
    rg_insc : '', 
    logradouro : '', 
    numero : '', 
    complemento : '', 
    cep : '', 
    bairro : '', 
    cidade : '', 
    estado : '', 
    telefonecomercial : '',
    celular : '', 
    email : ''
  })
  const expectedColumns = ["razaosocial", "nomefantasia", "cpf_cnpj", "rg_insc", "logradouro", "numero", 
    "complemento", "cep", "bairro", "cidade", "estado", "telefonecomercial","celular", "email"
  ];

  const handleFileUpload = (event) => {
  
    setLoading(true);
    setError("");
    const file = event.files[0];
    
    if (file) {
      const reader = new FileReader();
      reader.onload = ({ target }) => {
        Papa.parse(target.result, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => {
            const parsedData = result.data;

           // console.log(parsedData)
            const fileColumns = Object.keys(parsedData[0] || {});
            
            const isValid = expectedColumns.every(col => fileColumns.includes(col));
    
            if (!isValid) {
              setError("Erro de Validação! O arquivo CSV não possui as colunas esperadas.");
              setData([]);
              if (fileUploadRef.current) {
                fileUploadRef.current.clear();
              }
            } else {
              setData(parsedData);
              setData((prevData)=>([
              ...parsedData.map(function(item){
                return {
                        ...item,
                        razaosocial : removeCaracteresEspeciais(item.razaosocial),
                        nomefantasia : removeCaracteresEspeciais(item.razaosocial),
                        logradouro : removeCaracteresEspeciais(item.logradouro),
                        cidade : removeCaracteresEspeciais(item.cidade),
                        validDate : validarCpfCnpj(item.cpf_cnpj)
                      } 
              })
            ]))
            }
            
            setLoading(false);
          },
          error: () => {
            setError("Erro ao ler o arquivo CSV.");
            setLoading(false);
          }
        });
      };
      reader.readAsText(file);
    }
  };

  const handleClear = () => {
    setData([]);
    setLoading(false);
    setSelectedData([])
    setSelectAll(false)
    setError("");
    if (fileUploadRef.current) {
      fileUploadRef.current.clear();
    }
  };


  function removeCaracteresEspeciais(str) {
     return str.replace(/['"]/g, ' ');
  }


   const onSelectionChange = (event) => {
            const value = event.value;
            if(selectedData.length >3000){
              showMessage('error', 'O limite de envio é de 1000 registros por vez!', 'O limite de envio é de 1000 registros por vez!')
              return
            }
            setSelectedData(value);
    
            // Atualiza o estado do botão "Selecionar Todos"
            const allSelected = data.every(c => value.some(s => s.cpf_cnpj === c.cpf_cnpj));
            setSelectAll(allSelected);
        };

    
        const onSelectAllChange = (event) => {
            const checked = event.checked;
            if(data.length >3000){
              showMessage('error', 'O limite de envio é de 1000 registros por vez!', 'O limite de envio é de 1000 registros por vez!')
              return
            }
            if (checked) {
                const newSelected = [
                    ...data.filter(s => !data.some(c => c.cpf_cnpj === s.cpf_cnpj)),
                    ...data
                ];
                setSelectedData(newSelected);
            } else {
                const remaining = selectedData.filter(s => !data.some(c => c.cpf_cnpj === s.cpf_cnpj));
                setSelectedData(remaining);
            }
    
            setSelectAll(checked);
        };
    const renderFooter = () => (
    <div style={{ textAlign: 'right' }}>
        Selecionado(s) {selectedData.length} registro(s) de {data.length} registro(s)
    </div>)

    const handlerSizeCol = (col) =>{
        switch(col){
          case 'cpf_cnpj': return '60px';
          case 'rg_insc': return '50px';
          case 'razaosocial': return '350px';
          case 'nomefantasia': return '300px';
          case 'logradouro': return '250px';
          case 'complemento': return '100px';
          case 'cep': return '50px';
          case 'bairro': return '100px';
          case 'cidade': return '100px';
          case 'estado': return '30px';
          case 'email': return '200';
          default: return '60px';
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCliente(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
const toastBottomCenter = useRef(null);
 const showMessage = (severity, title, text) => {
        const label = title;

        toastBottomCenter.current.show({ severity: severity, title: label, detail: text, life: 3000 });
    };

  function validarCpfCnpj(valor) {
  valor = valor.replace(/[^\d]+/g, '');

  if (valor.length === 11) {
    // Validação de CPF
    if (/^(\d)\1{10}$/.test(valor)) return false;
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(valor.charAt(i)) * (10 - i);
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(valor.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(valor.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(valor.charAt(10));
  }

  if (valor.length === 14) {
    // Validação de CNPJ
    if (/^(\d)\1{13}$/.test(valor)) return false;
    let tamanho = valor.length - 2;
    let numeros = valor.substring(0, tamanho);
    let digitos = valor.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    tamanho += 1;
    numeros = valor.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resultado === parseInt(digitos.charAt(1));
  }

  // Nem CPF nem CNPJ válido
  return false;
}

const isRowSelectable = (rowData) => {
    console.log(rowData.validDate)
    return rowData.validDate; // só permite seleção se 'ativo' for true
  };

  return (
    <Layout loading={loading}>
      
    <div className="p-4">
      <Toast ref={toastBottomCenter} position="top-right" />
      <Card title="Importação de Clientes" className="shadow-none">
        <div className="flex flex-wrap gap-0" >  
             
                <FileUpload
                    ref={fileUploadRef}
                    disabled={editando > 0}
                    mode="basic"
                    accept=".csv"
                    auto
                    onClick ={(e)=>console.log(e)}
                    customUpload
                    uploadHandler={handleFileUpload}
                    chooseLabel="Selecionar Arquivo (.csv)"
                  />
                  <Button className="ml-2" disabled={!data || selectedData.length > 0 || editando > 0} severity="warning" label="Limpar dados " onClick={()=>{
                  handleClear()
                  }}/>
                 
            
        </div>
       
      </Card>
      {data.length === 0 ? 
      <>
      <span>* Formato do arquivo (separador <strong>;</strong> ). Coluna pode ficar vazia, mas não pode ser omitida.</span>
     
      </> : null }
      <br/>
      <br/>
      <span>Colunas esperadas: </span>
      <br/>
      <br/>
        {
          data.length === 0 && expectedColumns.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span style={{ marginRight: '5px' }}>;</span>}
              <Chip 
                label={item} 
                style={{ padding: '0 5px', marginRight: '5px' }} 
              />
            </React.Fragment>
          ))
        }

      {error && !loading && (
        <div className="mt-4">
          <Message severity="error" text={error} />
        </div>
      )}
      {
        editando > -1 ? 
      
      <Card>
        <div className="flex flex-wrap gap-0" > 
            <div className="col-12 md:col-2">
              <span className="text-sm">CPF/CNPJ</span>
              <InputText value={cliente.cpf_cnpj} name="cpf_cnpj" onChange={handleChange} className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-2">
              <span className="text-sm">RG/Insc. Est.</span>
              <InputText value={cliente.rg_insc} name="rg_insc" onChange={handleChange}  className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-5">
              <span className="text-sm">Nome/Razão Social</span>
              <InputText value={cliente.razaosocial} name="razaosocial" onChange={handleChange}  className="w-full mt-2"/>
            </div>
             <div className="col-12 md:col-3">
              <span className="text-sm">Apelido/Nome Fantasia</span>
              <InputText value={cliente.nomefantasia} name="nomefantasia" onChange={handleChange}  className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-4">
              <span className="text-sm">Logradouro</span>
              <InputText value={cliente.logradouro} name="logradouro" onChange={handleChange}  className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-1">
              <span className="text-sm">Número</span>
              <InputText value={cliente.numero} name="numero" onChange={handleChange}  className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-3">
              <span className="text-sm">Complemento</span>
              <InputText value={cliente.complemento} name="complemento" onChange={handleChange}  className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-1">
              <span className="text-sm">CEP</span>
              <InputCEP
                    name="cep" onChange={handleChange}
                    value={cliente.cep} 
                    setDataCep = {(data)=>{
                        //  console.log(data)
     
                        if(data){

                                setCliente(prevState => ({
                              ...prevState,
                                logradouro : data.logradouro, 
                                complemento : data.complemento, 
                                bairro : data.bairro,
                                cidade : data.localidade, 
                                estado : data.uf
                          }));
                        }else{
                          /*
                            setData((prevState)=>({
                                ...prevState, 
                                logradouro : '', 
                                complemento : '', 
                                bairro : '',
                                cidade : '', 
                                estado : ''
                            }))
                                */
                        }
                       
                          
                      }}
                    className="w-full mt-2"
                />

                
            </div>
            <div className="col-12 md:col-3">
              <span className="text-sm">Bairro</span>
              <InputText value={cliente.bairro} className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-4">
              <span className="text-sm">Cidade</span>
              <InputText value={cliente.bairro} className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-2">
              <span className="text-sm">Estado</span>
              <InputText value={cliente.bairro} className="w-full mt-2"/>
            </div>
            <div className="col-12 md:col-6">
              <span className="text-sm">Email</span>
              <InputText value={cliente.email} className="w-full mt-2"/>
            </div>
        </div>
         <div className="flex flex-wrap gap-0" > 
            <div className="col-12 md:col-4 flex flex-end">
                  <Button severity="warning" icon='pi pi-times' onClick={()=>{
                    setEditando(-1)
                    setCliente({
                                razaosocial : '', 
                                nomefantasia : '', 
                                cpf_cnpj : '', 
                                rg_insc : '', 
                                logradouro : '', 
                                numero : '', 
                                complemento : '', 
                                cep : '', 
                                bairro : '', 
                                cidade : '', 
                                estado : '', 
                                telefonecomercial : '',
                                celular : '', 
                                email : ''
                              })
                  }}/>
                  <Button severity="success" icon='pi pi-save' className="ml-2" onClick={()=>{
                    setData((prevData)=>prevData.map(function(item, index){
                      return index === editando ? {...cliente} : item
                    }))
                    setEditando(-1)
                    setCliente({
                                razaosocial : '', 
                                nomefantasia : '', 
                                cpf_cnpj : '', 
                                rg_insc : '', 
                                logradouro : '', 
                                numero : '', 
                                complemento : '', 
                                cep : '', 
                                bairro : '', 
                                cidade : '', 
                                estado : '', 
                                telefonecomercial : '',
                                celular : '', 
                                email : ''
                              })
                  }}/>
            </div>
          </div>
      </Card> : null }
      {!loading && data.length > 0 && (
        <Card title="Dados do CSV" className="mt-0 shadow-none">
          <span style={{fontSize : '10px', color: '#f00'}}>* Registros marcados em vermelho, indicam que o campo CPF/CNPJ é inválido! Verifique/corrija antes da importação</span>
          <DataTable 
            disabled ={editando > -1}
            style={{ fontSize: '10px' }}
            footer={renderFooter} 
            onValueChange={(filteredItems) => {                    
                    setTotalRegistros(filteredItems.length)
                }} 
              rows={10} // Número de itens por página
            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
            editMode="row"
            selection={selectedData}
            onSelectionChange={onSelectionChange}
            selectAll={selectAll}
            onSelectAllChange={onSelectAllChange}
            value={data} 
            paginator 
            selectionMode="multiple"
             rowSelectionMode="checkbox"

            rowClassName={(rowData) => rowData.validDate ? '' : 'row-inativo'}
            dataKey="cpf_cnpj">
              <Column selectionMode="multiple" disabled={editando > -1}/>
            <Column header='Editar' disabled={editando > -1} body={(row, { rowIndex })=> <Button icon ={'pi pi-user-edit'} disabled={editando > 0} severity="info" onClick={()=>{
              if(selectedData.length === 0){
                setEditando(rowIndex)
                    setCliente({
                      ...row
                    })
              }else{
                showMessage('warn', 'Importação Clientes', 'Você precisa desmarcar os clientes antes de EDITAR!')
              }
               
            }}></Button>}/>
            {Object.keys(data[0]).map((col, index) => (
              <Column 
                  key={index} 
                  field={col} 
                  style={{width :handlerSizeCol(col)}} 
                  header={col} 
                  sortable />
            ))}
          </DataTable>
          <span style={{fontSize : '10px'}}>** O processo de importação é feito através de transação, ou seja, 
            caso um ou mais registros apresentem erro, todo o processo é cancelado, isso é feito para evitar insersões duplicadas.</span>
        </Card>

        
      )}

      <div className="mt-4 flex gap-4">
       
        {selectedData.length !== 0 ? <><Button disabled={loading} severity="danger" onClick={()=>{
            confirmDialog({
                    message: 'Confirma a exclusão do(s) '+selectedData?.length+' registro(s) agora?',
                    header: 'Confirmação',
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: 'Sim',
                    rejectLabel: 'Não',
                    accept: () => {
                      if(selectAll){
                        handleClear()
                      }else{
                        setData(data.filter(item => 
                          !selectedData.some(sel => sel.cpf_cnpj === item.cpf_cnpj)
                        ));
                      }
                        
                    } 
                });
        }}>Remover da Lista</Button>

        <Button disabled={loading} severity="info" onClick={()=>{
            confirmDialog({
                    message: 'Confirma a importação do(s) '+selectedData?.length+' registro(s) agora?',
                    header: 'Confirmação',
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: 'Sim',
                    rejectLabel: 'Não',
                    accept: () => {
                       
                        const teste = selectedData.map(function(item){ 
                          return {razaosocial : item.razaosocial}
                        })

                        Conexao.post('clientesController/actionImportarCliente?idusuario='+dataEmpresa.idrevenda+'&idempresa='+dataEmpresa.idempresa, {
                          clientes: selectedData
                        }).then(response=>{

                            if(response.status === 200 && response.data.status === 'OK'){
                              showMessage('success', 'Importação Clientes', 'Registros inseridos com sucesso!')
                              if(selectAll){
                                handleClear()
                                return;
                              }

                              setData(data.filter(item => 
                                !selectedData.some(sel => sel.cpf_cnpj === item.cpf_cnpj)
                              ));

                              //setData(newSelected);
                              setSelectAll(false)

                              setSelectedData([])

                            }else{

                              showMessage('warn', 'Importação Clientes', 'Não foi possível inserir!')
                              
                            }
                        }).catch(error=>{

                            showMessage('error', 'Importação Clientes', 'Não foi possível inserir!')

                        })
                    } 
                });
        }}>Importar Dados</Button></> : null }
      </div>
      
    </div>
    </Layout>
  );
};

export default ImportClientesCSV;